import React, { useState, useEffect } from 'react';
import { Steps, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import processIcon from '../../../assets/icons/processStep.svg';
import finishIcon from '../../../assets/icons/finishStep.svg';
import { EyeOutlined } from '@ant-design/icons';
import { ArrowDown01Icon, ArrowUp01Icon } from 'hugeicons-react';

const { Step } = Steps;
const { Text } = Typography;

function StagesMortgages({ protagorasStage }) {
	const { t } = useTranslation();
	const [collapsed, setCollapsed] = useState({});

	//TODO: añadir traducciones
	const steps = [
		{
			title: 'stages.documents',
			substeps: [
				{ title: 'stages.awaiting_documents', value: 'awaiting_documents' },
				{
					title: 'stages.awaiting_documents_verification',
					value: 'awaiting_documents_verification'
				}
			],
			stage: ['documents']
		},
		{
			title: 'bank.waitingForOffer',
			substeps: [{ title: 'stages.scoring_pending', value: 'scoring_pending' }],
			stage: ['scoring_pending']
		},
		{
			title: 'stages.offer_available',
			substeps: [{ title: 'stages.scoring_done', value: 'scoring_done' }],
			stage: ['scoring_done']
		},
		{
			title: 'stages.preliminary_checks',
			substeps: [
				{ title: 'stages.ER_pending_starting', value: 'ER_pending_starting' },
				{ title: 'stages.ER_pending_solving', value: 'ER_pending_solving' },
				{ title: 'stages.ER_approved', value: 'ER_approved' },
				{ title: 'stages.ER_pending_sinfonia', value: 'ER_pending_sinfonia' }
			],
			stage: ['er']
		},
		{
			title: 'stages.formalization',
			substeps: [
				{
					title: 'stages.formalization_pending_IJ',
					value: ['formalization_pending_scoring', 'formalization_pending_IJ']
				},
				{
					title: 'stages.formalization_pending_appraisal',
					value: 'formalization_pending_appraisal'
				},
				{ title: 'stages.formalization_pending_FEIN', value: 'formalization_pending_FEIN' },
				{
					title: 'stages.formalization_pending_FEIN_signed',
					value: 'formalization_pending_FEIN_signed'
				},
				{
					title: 'stages.formalization_pending_insurance',
					value: 'formalization_pending_insurance'
				},
				{
					title: 'stages.formalization_pending_sign_date',
					value: 'formalization_pending_sign_date'
				},
				{ title: 'stages.formalization_pending_sign', value: 'formalization_pending_sign' }
			],
			stage: ['formalization', 'finish']
		}
	];

	useEffect(() => {
		setCollapsed((prev) => {
			const newCollapsed = {};
			steps.forEach((_, index) => {
				newCollapsed[index] = true;
			});
			return newCollapsed;
		});
	}, []);

	const currentStep = steps.findIndex((step) => {
		return (
			protagorasStage?.protagorasStage && step.stage.includes(protagorasStage?.protagorasStage)
		);
	});

	const currentSubstep =
		steps[currentStep]?.substeps?.findIndex((substep) => {
			const values = Array.isArray(substep.value) ? substep.value : [substep.value];
			return values.includes(protagorasStage?.substage);
		}) ?? -1;

	const toggleCollapse = (index) => {
		setCollapsed((prev) => ({
			...prev,
			[index]: !prev[index]
		}));
	};

	const iconStep = (index) => {
		if (currentStep < index) {
			return <EyeOutlined style={{ fontSize: 16, color: '#BDBDBD' }} />;
		}
		if (currentStep === index) {
			return <img src={processIcon} alt="processIcon" />;
		}
		if (currentStep > index) {
			return <img src={finishIcon} alt="finishIcon" />;
		}
	};

	return (
		<div style={{ background: '#FFFFFF' }}>
			{!isMobileOnly && (
				<Text style={{ fontSize: 16, color: '#757575', fontWeight: 700, lineHeight: '24px' }}>
					{t('document.modatTitlteSteper')}
				</Text>
			)}
			<div style={{ marginTop: !isMobileOnly && 16 }}>
				<Steps direction="vertical" size="small" className="stages-steps" current={currentStep}>
					{steps.map((step, index) => {
						return (
							<Step
								key={index}
								icon={iconStep(index)}
								status={'process'}
								title={
									<div
										style={{
											width: '100%',
											display: 'flex',
											cursor: 'pointer',
											alignItems: 'center',
											justifyContent: 'space-between',
											color:
												currentStep === index
													? '#006dff'
													: currentStep < index
													? '#BDBDBD'
													: '#212121'
										}}
										onClick={() => toggleCollapse(index)}>
										{t(step.title)}
										{!collapsed[index] ? (
											<ArrowUp01Icon size={18} />
										) : (
											<ArrowDown01Icon size={18} />
										)}
									</div>
								}
								description={
									<div
										style={{
											display: collapsed[index] ? 'none' : 'flex',
											flexDirection: 'column',
											marginTop: 6
										}}>
										{step.substeps?.map((substep, subIndex) => {
											const isLast = subIndex === step.substeps.length - 1;
											let substepColor = '#BDBDBD';
											if (
												currentStep > index ||
												(currentStep === index && subIndex <= currentSubstep)
											) {
												substepColor = '#212121';
											}

											return (
												<Text
													key={subIndex}
													style={{ color: substepColor, marginBottom: isLast ? 0 : 8 }}>
													{t(substep.title)}
												</Text>
											);
										})}
									</div>
								}
							/>
						);
					})}
				</Steps>
			</div>
		</div>
	);
}

export default StagesMortgages;
